import { useTranslation } from "react-i18next";

import { BackIcon } from "~/components/ui/icons/back";
import { ModalClose } from "~/components/ui/modal";

import type { OrderNavigationType } from "./order-navigation";
import { OrderNavigation } from "./order-navigation";

type OrderMobileHeaderProps = {
  brandId: string;
} & OrderNavigationType;

export const OrderMobileHeader: React.FC<OrderMobileHeaderProps> = ({
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <div className="sticky top-0 z-10 flex justify-between border-b border-gray-300 bg-white px-4 pb-4 lg:hidden">
      <ModalClose asChild>
        <button
          type="button"
          className="flex w-full items-center focus-visible:ring-2 focus-visible:ring-gray-900/30"
        >
          <BackIcon className="mr-2 size-6" />
          <p>{t("rating.open_order")}</p>
        </button>
      </ModalClose>
      <OrderNavigation {...props} />
    </div>
  );
};
